// extracted by mini-css-extract-plugin
module.exports = {"search":"BaseToolsSearch_search_2OIJS","search__button":"BaseToolsSearch_search__button_28VYf"};